import { createUseStyles } from 'react-jss';
import React, { FC, Fragment } from 'react';
import { capitalize, Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { formatDate } from 'src/utils/DateUtils';
import HipcomIcon from 'src/images/hipcom-avatar.png';

interface Props {
  message?: string;
  createdAt?: string;
  loading?: boolean;
}

const useStyles = createUseStyles({
  message: {
    color: '#b12b2b',
  },
  itemMessage: {
    padding: 25,
    background: '#fff3f3',
    border: '1px solid #ff0000',
    borderRadius: '20px 20px 0 20px',
    lineHeight: '21px',
    width: 'calc(100% - 120px)',
    marginRight: 70,
    marginBottom: 35,
    position: 'relative',
    '&:before': {
      content: `''`,
      position: 'absolute',
      bottom: 0,
      right: -70,
      display: 'block',
      width: 60,
      height: 60,
      borderRadius: 100,
      background: `#ff0000 url('${HipcomIcon}') no-repeat center`,
      backgroundSize: '90%',
    },
  },
  meta: {
    fontSize: 12,
    marginTop: 15,
    color: '#b12b2b',
  },
});

const EmployeeMessage: FC<Props> = ({ message, createdAt, loading }) => {
  const classes = useStyles();

  return (
    <div className={classes.itemMessage}>
      {!loading ? (
        <Typography variant='body1' className={classes.message}>
          {message?.split('\n').map((text, key) => (
            <Fragment key={key}>
              {text}
              <br />
            </Fragment>
          ))}
        </Typography>
      ) : (
        <Skeleton height={100} />
      )}
      {!loading ? (
        <div className={classes.meta}>
          <em>{capitalize(formatDate(createdAt, 'YYYY-MM-DDTHH:mm:ss', 'dddd DD MMMM [à] H[h]mm'))}</em>
        </div>
      ) : (
        <Skeleton width={300} />
      )}
    </div>
  );
};

export default EmployeeMessage;
